export default __webpack_public_path__ + "static/media/warning_filled.b6a98f22.svg";